import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isGivenLocation, NavigationDestination } from 'helpers/navigation';
import { useInspectionStore } from '../store';

export function useTemplateIdFromInspection(): string | undefined {
  const location = useLocation();
  const inspection = useInspectionStore.use.inspection();
  const inspectionModel = useInspectionStore.use.inspectionModel();
  const templateId = inspectionModel?.template ?? inspection?.template._id;

  return useMemo(() => {
    if (isGivenLocation(NavigationDestination.inspections, location.pathname)) {
      return templateId;
    }
    return undefined;
  }, [templateId, location.pathname]);
}

